import { LoadingScreen } from '@/components/loading-screen';
import useAffiliateCode from '@/hooks/use-affiliate-code';
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(authenticated)/dashboard/_layout/admin/_layout',
)({
  beforeLoad: async ({ context, location }) => {
    if (context.auth.data?.me.role !== 'ADMIN' && !context.auth.loading) {
      throw redirect({
        to: '/dashboard/home',
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          redirect: location.href,
        },
      });
    }
  },
  pendingComponent: () => <LoadingScreen />,
  component: LayoutComponent,
});

function LayoutComponent(): JSX.Element {
  useAffiliateCode();

  return <Outlet />;
}
